import { defineComponent as n, computed as o, openBlock as i, createElementBlock as r, createElementVNode as e, toDisplayString as f, createCommentVNode as d, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "9f6d4ff2-f80e-458f-b56e-58e95af45397" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#9f6d4ff2-f80e-458f-b56e-58e95af45397)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h512v167H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 345h512v167H0z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ n({
  __name: "ga",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), c = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), r("title", k, f(t.flagName), 1)) : d("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=ga-311a845d.js.map
